import {
  CubeTexture,
  HDRCubeTexture,
  CubeTextureAssetTask,
  HDRCubeTextureAssetTask,
} from 'babylonjs'

export type IEnvTexture = CubeTexture | HDRCubeTexture
export type IEnvTextureTask = CubeTextureAssetTask | HDRCubeTextureAssetTask

export enum IMockSkyBoxType {
  BOX2D = '2d',
  BOX3D = '3d',
}

export type IMockSkyBox = {
  id: string
  type: string
  previewUrl: string
  path: string
  path2k?: string
  path4k?: string
  path8k?: string
  path16k?: string
  name: string
  modelIds?: string[]
}

export type ISkyBoxPreload = {
  id: string
  texture: IEnvTexture
}
